import { FC, useEffect, useReducer } from 'react'
import { css } from '@emotion/react'
import { typography } from '@lifedot/styles/typography'
import { palette } from '@lifedot/styles/palette'
import { StepsStyled } from '@/components/Dialogue/Steps'
import { SeoHead } from '@/components/Seo/Dialogue'
import { AddMarginWrapper } from '@lifedot/components/AddMarginWrapper'
import { mq } from '@lifedot/styles/mediaQuery'
import { GetStaticProps } from 'next'
import { QuestionSectionType } from '@/components/Dialogue/QuestionSectionType'
import { useDiscoverDialogue } from '@lifedot/hooks/use-discover-dialogue'
import { useRouter } from 'next/router'
import { router } from '@lifedot/router'
import { STEP } from '@lifedot/constants/dialogue'

export const getStaticProps: GetStaticProps = () => ({ props: {} })

const styles = {
  wrapper: css({
    paddingTop: 40,
    maxWidth: 740,
    height: '100vh',
    margin: '0 auto',
    [mq('sp')]: {
      padding: 20
    }
  }),
  title: css({
    textAlign: 'center'
  }),
  subTitle: css({
    position: 'relative',
    padding: '0 28px',
    fontWeight: 'normal',
    '::before, ::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      width: 20,
      height: 2,
      backgroundColor: palette.black
    },
    '::before': {
      left: 0,
      transform: 'rotate(60deg)'
    },
    '::after': {
      right: 0,
      transform: 'rotate(-60deg)'
    }
  }),
  mainTitle: css({
    display: 'inline-block',
    marginTop: 8,
    backgroundColor: palette.marker,
    padding: '0 2px',
    letterSpacing: 2,
    fontSize: 40,
    [mq('sp')]: {
      fontSize: 32
    }
  })
}

const DialoguePage: FC = () => {
  const [{ status }, { answer }] = useDiscoverDialogue(STEP.FIRST)
  const [selected, select] = useReducer((...args: [boolean, string]) => {
    answer(args[1])
    return true
  }, false)
  const nextRouter = useRouter()
  useEffect(() => {
    if (status === 'ANSWERED' && selected)
      nextRouter.push(router.dialogueStep(2))
  }, [nextRouter, selected, status])

  return (
    <>
      <SeoHead />
      <div css={styles.wrapper}>
        <AddMarginWrapper spacing={8}>
          <h1 css={styles.title}>
            <span css={[typography.textM, styles.subTitle]}>
              あなたにあったお墓が見つかる
            </span>
            <br />
            <span css={styles.mainTitle}>ぴったりお墓診断</span>
          </h1>
          <StepsStyled current={1} />
          <QuestionSectionType handleAnswer={select} />
        </AddMarginWrapper>
      </div>
    </>
  )
}

export default DialoguePage
